import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const paymentUpdateModeDict: Array<Dictionary> = []

for (const code of ['always', 'with_status', 'never']) {
    paymentUpdateModeDict.push({ code: code, name: i18n.t(`dictionary.paymentUpdateMode.${code}`).toString() })
}

export { paymentUpdateModeDict }
